<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-11-10 20:06:36
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-09-20 16:45:36
-->
<template>
	<div class="mt-12 yx-form-wrap">
		<el-form :inline="true" :model="formData" label-width="96px">
			<el-form-item label="商品ID">
				<el-input v-model="formData['itemId']" placeholder="请输入"></el-input>
			</el-form-item>
			<el-form-item label="活动ID">
				<el-input v-model="formData['activityId']" placeholder="请输入"></el-input>
			</el-form-item>
			<el-form-item label="商品标题" v-if="tabName === '1'">
				<el-input v-model="formData['itemTitle']" placeholder="请输入"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="onSubmit">筛选</el-button>
				<el-button @click="onClear">清空</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
import throttle from 'lodash/throttle';
export default {
	name: 'search',
	props: {
		tabName: {
			type: [String, Number],
			default: '',
		},
	},
	data() {
		return {
			formData: {},
			labelWidth: '140px',
		};
	},
	methods: {
		onClear() {
			this.formData = {};
			this.onSubmit();
		},
		onSubmit: throttle(function () {
			this.$emit('onSubmit', this.formData);
		}, 1000),
	},
};
</script>

<style lang="less" scoped></style>
